/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * GetDocument.Insider
 * OpenAPI spec version: 1.0.0
 */

export type OrganisationBillingPaymentStatus =
    (typeof OrganisationBillingPaymentStatus)[keyof typeof OrganisationBillingPaymentStatus];

export const OrganisationBillingPaymentStatus = {
    PaymentRequired: 0,
    Paid: 1,
    CancelsAtPeriodEnd: 2,
    PaymentAttention: 3,
    Expired: 4,
} as const;
